import styled from 'styled-components';
import { COLOURS } from '@belong/themes';

export const ContactUsWrapper = styled.div`
  background-color: ${COLOURS.GREY_100};
  border-radius: 8px;
  padding: 16px;
  margin: 0 16px;
`;
